export enum EKwikUIProgressBarSize {
  XS = "xs",
  S = "s",
  M = "m",
  L = "l",
  XL = "xl"
}
export const VKwikUIProgressBarSize = [
  EKwikUIProgressBarSize.XS,
  EKwikUIProgressBarSize.S,
  EKwikUIProgressBarSize.M,
  EKwikUIProgressBarSize.L,
  EKwikUIProgressBarSize.XL
] as const;

export type TKwikUIProgressBarSize = (typeof VKwikUIProgressBarSize)[number];
